export const getDate = (date: Date) => {
  return `${date.getFullYear()}-${
    date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)
  }-${date.getDate() > 9 ? date.getDate() : "0" + date.getDate()}`;
};

export const getTime = (date: Date) => {
  return `${date.getHours()}:${date.getMinutes()}`;
};

export const leadingZeros = (num, places) => String(num).padStart(places, "0");
// HTML Decode
export const HTMLdecode = (html: string) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};
